export const OBJECT_VIEW_MODE = {
  COLUMNS: "columns",
  KEY_VALUE: "keyValue",
  JSON: "json",
} as const

export type ObjectViewMode =
  (typeof OBJECT_VIEW_MODE)[keyof typeof OBJECT_VIEW_MODE]

export const METRICS_VIEW_MODE = {
  TABLE: "table",
  CARD: "card",
} as const

export type MetricsViewMode =
  (typeof METRICS_VIEW_MODE)[keyof typeof METRICS_VIEW_MODE]

export const SIMULATION_INPUT_VIEW_MODE = {
  TEXT: "text",
  MARKDOWN: "markdown",
} as const

export type SimulationInputViewMode =
  (typeof SIMULATION_INPUT_VIEW_MODE)[keyof typeof SIMULATION_INPUT_VIEW_MODE]
